import { trackInteraction, trackPromotionClicked, trackPromotionViewed } from 'client/javascript/analytics';

export const INTERACTION_LABELS = {
  PROMO_BANNER_LINK_LABEL: 'Click - Homepage Takeover Module'
};

// Creating a duplicate link in requirement for new data tracking event.
export const SELECTORS = {
  PROMO_BANNER_LINK: '.analytics-homepage-promo-link',
  PROMOTION_HERO_TAKEOVER_LINK: '.analytics-homepage-promo-link',
  PROMO_HERO_TAKEOVER_LABEL: '.card-product__promo--takeover',
  MEDIA_TEXT_ACROSS_ITEM: '.media-text-one-across-item',
  ANALYTICS_PROMOTION_ID_LINK: '.analytics-promotion-id'
};

const MEDIA_TEXT_PAGE_ELEMENT = 'Media Text One Across Standard';
const MEDIA_TEXT_PROMO_ID_NOT_SET = 'Promo ID Not Set';

export const setupPromoModuleAnalytics = (moduleDomNode) => {
  const linkNode = moduleDomNode.querySelector(SELECTORS.PROMO_BANNER_LINK);

  if (linkNode) {
    linkNode.addEventListener('click', () => {
      trackInteraction({ label: INTERACTION_LABELS.PROMO_BANNER_LINK_LABEL });
    });
  }
};

/**
 * Homepage promotion_id details tracking
 * @param promotion_id // The ID of the promotion
 * @param name // module name of the promotion
 * @param page_type // The type of page to track
 */

// TODO: Assign promo_code once the module has been configured to have promotion code.

export const setupPromotionModuleAnalytics = (moduleDomNode) => {
  const linkNode = moduleDomNode.querySelector(SELECTORS.PROMOTION_HERO_TAKEOVER_LINK);
  const props = {
    promotion_name: moduleDomNode.querySelector(SELECTORS.PROMO_HERO_TAKEOVER_LABEL).innerText,
    page_type: document.documentElement.className,
    page_element: 'Hero Takeover Module',
    promo_code: ''
  };

  if (linkNode) {
    linkNode.addEventListener('click', () => {
      trackPromotionClicked(props);
    });
  }
};

/**
 * Homepage promotion_id details tracking for scroll events
 * @param promotion_id // The ID of the promotion
 * @param name // module name of the promotion
 * @param page_type // The type of page to track
 */

// TODO: Assign promo_code once the module has been configured to have promotion code.

export const setupScrollEventTrackingPromo = (moduleDomNode) => {
  const props = {
    promotion_name: moduleDomNode.querySelector(SELECTORS.PROMO_HERO_TAKEOVER_LABEL).innerText,
    page_type: document.documentElement.className,
    page_element: 'Hero Takeover Module',
    promo_code: ''
  };

  const options = {
    rootMargin: '-50% 0% -50% 0%',
    threshold: 0
  };

  const promoObserver = new IntersectionObserver((entries) => {
    const promotion = entries[0]; //  The promotion to track.
    if (promotion.isIntersecting) {
      trackPromotionViewed(props);
    }
  }, options);

  promoObserver.observe(moduleDomNode);
};

export const setupMediaAndTextOneAcrossAnalytics = () => {
  const mediaTextOneLinks = document.querySelectorAll(SELECTORS.MEDIA_TEXT_ACROSS_ITEM);

  Array.from(mediaTextOneLinks).forEach((mediaLinkNode) =>
    mediaLinkNode.addEventListener('click', handleMediaTextPromoClick)
  );
};

function handleMediaTextPromoClick(event) {
  const { parentNode } = event.currentTarget;
  let { analyticsPromotionId } = parentNode.querySelector(SELECTORS.ANALYTICS_PROMOTION_ID_LINK).dataset;
  analyticsPromotionId ??= MEDIA_TEXT_PROMO_ID_NOT_SET;

  const props = {
    promotion_name: analyticsPromotionId.toUpperCase(),
    page_type: document.documentElement.className,
    page_element: MEDIA_TEXT_PAGE_ELEMENT,
    promo_code: analyticsPromotionId
  };
  trackPromotionClicked(props);
}

export const setupMediaAndTextScrollAnalytics = () => {
  const options = {
    rootMargin: '0px',
    threshold: 0.5
  };

  const promoMediaObserver = new IntersectionObserver((entries) => {
    if (entries[0].intersectionRatio <= 0) return;

    const promotionAnalyticsId = entries[0]; //  The promotion to track.
    let promotionIdValue = promotionAnalyticsId.target.dataset.analyticsPromotionId;
    promotionIdValue ??= MEDIA_TEXT_PROMO_ID_NOT_SET;

    const props = {
      promotion_name: promotionIdValue.toUpperCase(),
      page_type: document.documentElement.className,
      page_element: MEDIA_TEXT_PAGE_ELEMENT,
      promo_code: promotionIdValue
    };

    if (promotionAnalyticsId.isIntersecting) {
      trackPromotionViewed(props);
    }
  }, options);

  const promotionIdElementsList = document.querySelectorAll(SELECTORS.ANALYTICS_PROMOTION_ID_LINK);
  if (promotionIdElementsList.length <= 0) return null;
  promotionIdElementsList.forEach((el) => {
    promoMediaObserver.observe(el);
  });
};

export const setupTrackingTakeoverModule = (contenfulModule) => {
  setupPromoModuleAnalytics(contenfulModule);
  setupPromotionModuleAnalytics(contenfulModule);
  setupScrollEventTrackingPromo(contenfulModule);
};
